import { render } from "./RenameModal.vue?vue&type=template&id=b93536f0&scoped=true&lang=pug"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"

import "./RenameModal.vue?vue&type=style&index=0&id=b93536f0&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93536f0"]])

export default __exports__